import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './standingsTableHeader.scss';

class CustomHeader extends Component {
  render() {
    return (
      <div 
        className={`standings-table-header ${this.props.textAlign} ${this.props.className || ''}`}
      >
        {this.props.title}
        <span className="standings-table-header-subtitle">{this.props.subtitle}</span>
        {this.props.withCaret && <div className="standings-table-header-arrow"></div>}
      </div>
    );
  }
}

CustomHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleColor: PropTypes.string,
  subtitleColor: PropTypes.string,
  textAlign: PropTypes.oneOf(['right', 'left', 'center', '']), // left center right
  withCaret: PropTypes.bool,
  className: PropTypes.string
};

CustomHeader.defaultProps = {
  textAlign: '',
  titleColor: '#fff',
  subtitleColor: '#a5a5a5',
  withCaret: true
};

export default CustomHeader;


// WEBPACK FOOTER //
// ./src/screens/components/standingsTableHeader/StandingsTableHeader.jsx